import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton";
import BasicTable from "../../../Components/Table/Material";
import useApi from "../../../Hooks/useApi";
import Tooltip from "@mui/material/Tooltip";
import { usePagination } from "../../../Hooks/usePagination";

import { SVG_DATA_UPLOAD } from "../../../Assets/SVG/svg_util";
import Common from "../../../Components/Layouts/Common";
import { Button, Link } from "@mui/material";
import { use } from "react";

const KIISubmissionCityList = () => {
  const { t } = useTranslation();
  const { request } = useApi();
  const navigate = useNavigate();
  const paginateProps = usePagination();

  const location = useLocation();
  const { kiiId, kiiName, questionId } = location?.state || {};
  const [kiiCityList, setKiiCityList] = useState();
  const [data, setData] = useState();

  const buttonConfigs = [
    {
      Icon: SVG_DATA_UPLOAD,
      tooltip: (row) =>
        row.status === "COMPLETED" ? "Already Data Uploated" : "Upload Data",
      bgColor: (row) =>
        row.status === "COMPLETED"
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#1976d2]",
      onClick: (navigate, row) => () => {
        if (row.status !== "COMPLETED") {
          navigate(`/kii-data-submission`, {
            state: {
              kiiId: kiiId,
              kiiName: kiiName,
              city: row.name,
              id: row.id,
              questionId: questionId,
              answerType: data.answerType,
              locationId: row.id,
            },
          });
        }
      },
    },
  ];

  const fetcKiiCityList = async () => {
    try {
      const response = await request(
        "GET",
        `/v1/kii/city-mapping/${kiiId}`,
        {},
        "kii_service"
      );
      setData(response);

      setKiiCityList(response.cities);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetcKiiCityList();
  }, []);

  const columns = [
    {
      id: "name",
      label: "City Name",
      minWidth: 170,
    },
    {
      id: "creationDate",
      label: "Assigned Date",
      minWidth: 100,
    },
    {
      id: "status",
      label: "Data Submission Status",
      minWidth: 100,
    },

    {
      id: "action",
      label: "Actions",
      minWidth: 170,
      align: "center",
      renderCell: (row) => {
        return (
          <div className="inline-flex space-x-2">
            {buttonConfigs.map(
              ({ Icon, tooltip, bgColor, onClick }, buttonIndex) => (
                <Tooltip title={tooltip(row)}>
                  
                  <button
                    key={buttonIndex}
                    onClick={onClick(navigate, row)}
                    className={`${bgColor(
                      row
                    )} border border-gray-300 h-8 w-8 text-white rounded-md flex items-center justify-center p-1`}
                  >
                    <Icon />
                  </button>
                </Tooltip>
              )
            )}
          </div>
        );
      },
    },
  ];
  
  useEffect(() => {
    if (!kiiId) {
      navigate("/manage-kii");
    }
  }, [kiiId]);

  return (
    <Common headline={"KII Data Submission City List"}>
      <div className=" bg-white  relative">
        <div className="flex mb-4 ">
          <h4 className=" font-bold text-gray-800 pr-2">KII Name:</h4>
          <h5>{kiiName}</h5>
        </div>
        {/* <div className="py-2 flex items-center justify-between">
        <div className="space-x-2">
          <Link to={"/select-kii-questionnaire-method"}>
            <Button variant="contained">Add New KII Questionnaire</Button>
          </Link>
          <Button>Export</Button>
          <Button>Print</Button>
        </div>
      </div> */}

        <BasicTable
          columns={columns}
          data={kiiCityList}
          paginateProps={paginateProps}
        />
      </div>
    </Common>
  );
};

export default KIISubmissionCityList;
